import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import { useOrgStore } from "../stores/org.store";
import type { ClientOrgMembership } from "@cliently/types";



export const useOrganizations = () => {
  const setOrganizations = useOrgStore((s) => s.setOrganizations);
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ["portal-organizations"],
    queryFn: async () => {
      const { data } = await api.get("/portal/my-organizations");
      const orgs = data as ClientOrgMembership[];
      setOrganizations(orgs);
      void queryClient.invalidateQueries({ queryKey: ["client-profile"] });
      return orgs;
    },
    /** Sans ça, les flags portail (métriques, bien-être) peuvent rester obsolètes 5 min après un changement praticien. */
    staleTime: 15_000,
    gcTime: 5 * 60_000,
  });
}



export const useJoinOrganization = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (accessCode: string) => {
      const { data } = await api.post("/portal/join-organization", {
        accessCode,
      });
      return data as ClientOrgMembership;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["portal-organizations"] });
    },
  });
}



export const useLeaveOrganization = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (orgId: string) => {
      await api.delete(`/portal/leave-organization/${orgId}`);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["portal-organizations"] });
    },
  });
}
